import moment from "moment";
import React from "react";
import { timeUntil } from "../utils";

const RemainingTime: React.FC<{ time: moment.Moment }> = props => {
  const duration = moment.duration(timeUntil(props.time));
  if (duration.asMilliseconds() > 0) {
    return <span>{duration.humanize()}</span>;
  }

  return <span>0 days</span>;
};

export default RemainingTime;
